import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import DOMPurify from "dompurify";
import aboutBanner from "../assets/images/page-titles/1.webp";

function Servicedetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const api_url =
    localStorage.getItem("api_url") || "http://localhost/inscape_backend/api/";
  const [serviceData, setServiceData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const company_id = localStorage.getItem("company_id") || "1";
  const employee_id = localStorage.getItem("employee_id") || "1";

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    if (id) {
      getServiceDetails();
    }
  }, [id]);

  useEffect(() => {
    const applyBackgrounds = () => {
      document.querySelectorAll(".bg-img")?.forEach((el) => {
        const img = el.querySelector("img");
        if (img) {
          const parent = el.parentElement;
          if (parent) {
            parent.style.backgroundImage = `url(${img.src})`;
            parent.style.backgroundSize = "cover";
            parent.style.backgroundPosition = "center";
            parent.classList.add("bg-img");
            if (el.classList.contains("background-size-auto")) {
              parent.classList.add("background-size-auto");
            }
          }
          el.remove();
        }
      });
    };

    const timer = setTimeout(applyBackgrounds, 100);
    return () => clearTimeout(timer);
  }, [serviceData]);

  const getServiceDetails = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("company_id", company_id);
      formData.append("employee_id", employee_id);
      formData.append("type", "2");
      formData.append("service_id", id);

      const response = await fetch(`${api_url}service.php`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.status === "1") {
        setServiceData(data.result);
        setError(null);
      } else {
        setError(data.error || "Service not found");
      }
    } catch (err) {
      console.error("Error fetching service details:", err);
      setError("Failed to load service details");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "400px",
          fontSize: "18px",
          color: "#666",
        }}
      >
        Loading service details...
      </div>
    );
  }

  if (error || !serviceData) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "400px",
          padding: "20px",
        }}
      >
        <h3 style={{ color: "#721c24", marginBottom: "20px" }}>
          {error || "Service not found"}
        </h3>
        <button
          onClick={() => navigate("/services")}
          style={{
            padding: "10px 20px",
            backgroundColor: "#ff6600",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Back to Services
        </button>
      </div>
    );
  }

  return (
    <>
      {/* Banner/Breadcrumb Section */}
      <section className="page-title-layout1 page-title-light bg-parallax bg-overlay text-center">
        <div className="bg-img">
          <img src={aboutBanner} alt="background" />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1 className="pagetitle-heading">{serviceData.service_title}</h1>
              <nav>
                <ol className="breadcrumb justify-content-center mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {serviceData.service_title}
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </section>

      {/* Service Details Section */}
      <section className="service-details pt-50 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <div className="service-item single-service-item mb-0">
                <div className="service-body">
                  {/* Short Description */}
                  <div className="service-intro mb-40">
                    <p className="service-short-desc">
                      {serviceData.service_short_dec}
                    </p>
                  </div>

                  {/* Divider */}
                  <div className="service-divider"></div>

                  <div
                    className="service-rich-content"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(
                        serviceData.service_long_dec.replace(/&nbsp;/g, " "),
                      ),
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <style>{`
        /* ── Page-level safety ── */
        body {
          overflow-x: hidden;
        }

        /* ── Short description ── */
        .service-short-desc {
          font-size: 18px;
          line-height: 1.8;
          color: #555;
          font-weight: 400;
          overflow-wrap: break-word;
          word-break: break-word;
          white-space: normal;
          max-width: 100%;
          display: block;
          margin: 0;
        }

        /* ── Divider ── */
        .service-divider {
          height: 2px;
          background: linear-gradient(to right, #ff6600, transparent);
          margin-bottom: 40px;
        }

        /* ── Rich content wrapper ── */
        .service-rich-content {
          display: block;
          width: 100%;
          max-width: 100%;
          box-sizing: border-box;
          font-size: 16px;
          line-height: 1.9;
          color: #333;
          overflow: visible;
          word-break: break-word;
          overflow-wrap: break-word;
        }

        /* ── Paragraphs ── */
        .service-rich-content p {
          display: block;
          width: 100%;
          max-width: 100%;
          box-sizing: border-box;
          margin-bottom: 20px;
          line-height: 1.9;
          overflow: visible;
          overflow-wrap: break-word;
          word-break: break-word;
          white-space: normal;
        }

        /* ── Bold ── */
        .service-rich-content p strong,
        .service-rich-content p b {
          display: inline;
          font-weight: 700;
          color: #222;
          overflow-wrap: break-word;
          word-break: break-word;
        }

        /* ── Headings ── */
        .service-rich-content h1,
        .service-rich-content h2,
        .service-rich-content h3,
        .service-rich-content h4,
        .service-rich-content h5,
        .service-rich-content h6 {
          margin-top: 35px;
          margin-bottom: 20px;
          font-weight: 700;
          color: #222;
          line-height: 1.4;
          word-break: break-word;
        }

        .service-rich-content h1 { font-size: 32px; color: #ff6600; }
        .service-rich-content h2 { font-size: 28px; color: #ff6600; }
        .service-rich-content h3 { font-size: 24px; }
        .service-rich-content h4 { font-size: 20px; }
        .service-rich-content h5 { font-size: 18px; }
        .service-rich-content h6 { font-size: 16px; }

        /* ── Lists ── */
        .service-rich-content ul,
        .service-rich-content ol {
          margin: 20px 0;
          padding-left: 30px;
        }

        .service-rich-content ul li,
        .service-rich-content ol li {
          margin-bottom: 12px;
          line-height: 1.8;
        }

        .service-rich-content ul { list-style-type: disc; }
        .service-rich-content ol { list-style-type: decimal; }

        .service-rich-content ul li::marker {
          color: #ff6600;
          font-weight: bold;
        }

        /* ── Blockquote ── */
        .service-rich-content blockquote {
          border-left: 4px solid #ff6600;
          padding: 20px;
          margin: 30px 0;
          font-style: italic;
          color: #555;
          background-color: #f9f9f9;
          border-radius: 4px;
        }

        /* ── Images ── */
        .service-rich-content img {
          max-width: 100%;
          height: auto;
          border-radius: 8px;
          margin: 25px 0;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          display: block;
        }

        /* ── Links ── */
        .service-rich-content a {
          color: #ff6600;
          text-decoration: none;
          border-bottom: 1px solid transparent;
          transition: all 0.3s ease;
          word-break: break-all;
        }

        .service-rich-content a:hover {
          border-bottom: 1px solid #ff6600;
        }

        /* ── Inline code ── */
        .service-rich-content code {
          background-color: #f5f5f5;
          padding: 3px 8px;
          border-radius: 4px;
          font-family: 'Courier New', Courier, monospace;
          font-size: 14px;
          color: #e83e8c;
        }

        /* ── Code block ── */
        .service-rich-content pre {
          background-color: #f5f5f5;
          padding: 20px;
          border-radius: 8px;
          overflow-x: auto;
          margin: 25px 0;
          border-left: 4px solid #ff6600;
          max-width: 100%;
        }

        .service-rich-content pre code {
          background-color: transparent;
          padding: 0;
          color: #333;
        }

        /* ── Table — make scrollable on small screens ── */
        .service-rich-content table {
          width: 100%;
          border-collapse: collapse;
          margin: 25px 0;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          /* Do NOT set min-width here; let wrapper handle overflow */
        }

        /* Wrap tables so they scroll horizontally on mobile */
        .service-rich-content table {
          display: block;
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
          white-space: nowrap;
        }

        .service-rich-content table th,
        .service-rich-content table td {
          padding: 12px 15px;
          text-align: left;
          border: 1px solid #e0e0e0;
          white-space: normal;
          min-width: 120px;
        }

        .service-rich-content table th {
          background-color: #ff6600;
          color: white;
          font-weight: 600;
        }

        .service-rich-content table tr:nth-child(even) { background-color: #f9f9f9; }
        .service-rich-content table tr:hover { background-color: #f5f5f5; }

        /* ── HR ── */
        .service-rich-content hr {
          border: none;
          border-top: 2px solid #e0e0e0;
          margin: 40px 0;
        }

        /* ── iFrame — responsive embed ── */
        .service-rich-content iframe {
          max-width: 100%;
          width: 100%;
          border-radius: 8px;
          margin: 25px 0;
          display: block;
        }

        /* ── Responsive ── */
        @media (max-width: 992px) {
          .service-short-desc {
            font-size: 17px;
          }
          .service-rich-content h1 { font-size: 28px; }
          .service-rich-content h2 { font-size: 24px; }
          .service-rich-content h3 { font-size: 21px; }
        }

        @media (max-width: 768px) {
          .service-short-desc {
            font-size: 16px;
            line-height: 1.7;
          }
          .service-rich-content {
            font-size: 15px;
          }
          .service-rich-content h1 { font-size: 24px; }
          .service-rich-content h2 { font-size: 20px; }
          .service-rich-content h3 { font-size: 18px; }
          .service-rich-content h4 { font-size: 16px; }
          .service-rich-content h5,
          .service-rich-content h6 { font-size: 15px; }
          .service-rich-content ul,
          .service-rich-content ol {
            padding-left: 20px;
          }
          .service-rich-content blockquote {
            padding: 14px 16px;
            margin: 20px 0;
          }
          .service-divider {
            margin-bottom: 28px;
          }
        }

        @media (max-width: 480px) {
          .service-short-desc {
            font-size: 15px;
          }
          .service-rich-content {
            font-size: 14px;
            line-height: 1.8;
          }
          .service-rich-content h1 { font-size: 21px; }
          .service-rich-content h2 { font-size: 18px; }
          .service-rich-content h3 { font-size: 16px; }
          .service-rich-content table th,
          .service-rich-content table td {
            padding: 8px 10px;
            font-size: 13px;
          }
          .service-rich-content pre {
            padding: 14px;
            font-size: 13px;
          }
        }
      `}</style>
    </>
  );
}

export default Servicedetails;